import {
    GESTION_OPERATIVA_RETRY_OFFER_BEGIN,
    GESTION_OPERATIVA_RETRY_OFFER_DISMISS_ERROR
} from '../constants';


export function retryOfferDMS( id ) {
    return (dispatch) => {
        dispatch({
            type: GESTION_OPERATIVA_RETRY_OFFER_BEGIN,
            data: id
        })
    }
}

export function dismissRetryOfferDMSError() {
    return {
      type: GESTION_OPERATIVA_RETRY_OFFER_DISMISS_ERROR
    }
}
